import { render, staticRenderFns } from "./PageDashboardEditor.vue?vue&type=template&id=6f7870c6"
import script from "./PageDashboardEditor.vue?vue&type=script&lang=js"
export * from "./PageDashboardEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports